import { useRouter } from "next/router";
import React, { useState } from "react";

function PrivacyPage() {
  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  return (
    <div>
      <section className="topBar">
        <div className="left-wrrow" onClick={goBack}>
          <span className="iconWrapper">
            <svg
              width="6"
              height="12"
              viewBox="0 0 6 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.46849 0.414376C5.79194 0.673133 5.84438 1.1451 5.58562 1.46855L1.96044 6.00003L5.58562 10.5315C5.84438 10.855 5.79194 11.3269 5.46849 11.5857C5.14505 11.8444 4.67308 11.792 4.41432 11.4685L0.414321 6.46855C0.195189 6.19464 0.195189 5.80542 0.414321 5.53151L4.41432 0.531506C4.67308 0.20806 5.14505 0.155619 5.46849 0.414376Z"
                fill="#333333"
              />
            </svg>
          </span>
        </div>
        <div className="middleContent">
          <h3>Terms and Conditions </h3>
        </div>
        <div className="rightContent"></div>
      </section>
      <section className="headerGap"></section>

      <section className="terms-app">
        <div className="terms-container">
          <p>
            These terms and conditions govern the use of services and products provided by AgriCare.
            By accessing or using the Company&#x27;s services, you agree to be bound by these Terms.
            Please read them carefully before proceeding.
          </p>

          <h2>Service Description:</h2>

          <ol>
            <li>
              AgriCare offers various profitable projects related to agriculture, including but not
              limited to data analytics, farm management, crop monitoring, and supply chain
              optimization.
            </li>
            <li>
              The services provided may vary and are subject to change at the discretion of the
              Company.
            </li>
          </ol>

          <h2>User Obligations:</h2>

          <ol>
            <li>
              Users must provide accurate, complete, and up-to-date information during registration
              and ensure the security of their account credentials.
            </li>
            <li>
              Users shall use the Company&#x27;s services only for lawful purposes and in accordance
              with all applicable laws and regulations.
            </li>
            <li>
              Users are responsible for maintaining the confidentiality of their account and shall
              not share their credentials with any third party.
            </li>
            <li>
              Users shall not engage in any activity that may disrupt or interfere with the
              Company&#x27;s services or network.
            </li>
          </ol>

          <h2>Data Privacy and Security:</h2>

          <ol>
            <li>
              AgriCare respects the privacy of its users. The collection, storage, and use of
              personal data are governed by the Company&#x27;s Privacy Policy.
            </li>
            <li>
              Users agree to provide accurate and complete data and grant the Company the right to
              collect and process their data for the purpose of providing services.
            </li>
            <li>
              The Company implements reasonable security measures to protect user data but cannot
              guarantee absolute security. Users are responsible for safeguarding their personal
              information.
            </li>
          </ol>
        </div>
      </section>
      <section className="headerGap"></section>
    </div>
  );
}

export default PrivacyPage;
